import { useEffect } from 'react';

export default function useHideKofiWidget(hide: boolean) {
    useEffect(() => {
        if (!hide) return;

        const widget = document.querySelector<HTMLDivElement>('[id^="kofi-widget-overlay-"]');
        widget?.classList.add('hidden');

        return () => widget?.classList.remove('hidden');
    }, [hide]);
}
